import { useEffect, useState } from "react";
import { C, font } from "../tokens";
import { setFaqSchema, clearFaqSchema } from "../lib/faqSchema";

// FAQ visível (accordion, estilo da marca) que TAMBÉM injeta o JSON-LD FAQPage.
// items: [{ q, a }]. Use em páginas que ainda não têm FAQ própria (ex.: posts).
export default function FaqSection({ items, title = "Perguntas frequentes" }) {
  const [open, setOpen] = useState(0);

  useEffect(() => {
    setFaqSchema(items);
    return () => clearFaqSchema();
  }, [items]);

  if (!items || !items.length) return null;

  return (
    <section style={{ background: C.bgAlt, padding: "56px 28px 72px" }}>
      <div style={{ maxWidth: 760, margin: "0 auto" }}>
        <h2 style={{ fontFamily: font, fontSize: 27, fontWeight: 800, letterSpacing: -0.6, color: C.text, margin: "0 0 24px" }}>
          {title}
        </h2>
        <div style={{ display: "flex", flexDirection: "column", gap: 12 }}>
          {items.map((it, i) => {
            const isOpen = open === i;
            return (
              <div
                key={i}
                style={{
                  background: C.surface,
                  border: `1px solid ${isOpen ? C.accentBorder : C.border}`,
                  borderRadius: 14,
                  overflow: "hidden",
                  transition: "border-color 0.2s",
                }}
              >
                <button
                  onClick={() => setOpen(isOpen ? -1 : i)}
                  aria-expanded={isOpen}
                  style={{
                    width: "100%",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    gap: 16,
                    padding: "18px 20px",
                    background: "none",
                    border: "none",
                    cursor: "pointer",
                    textAlign: "left",
                    fontFamily: font,
                    fontSize: 16.5,
                    fontWeight: 700,
                    color: C.text,
                  }}
                >
                  {it.q}
                  <span
                    style={{
                      flexShrink: 0,
                      width: 26,
                      height: 26,
                      borderRadius: 8,
                      background: isOpen ? C.accent : C.accentLight,
                      color: isOpen ? "#fff" : C.accent,
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      transition: "background 0.2s, transform 0.2s",
                      transform: isOpen ? "rotate(45deg)" : "none",
                    }}
                  >
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.6" strokeLinecap="round">
                      <path d="M12 5v14M5 12h14" />
                    </svg>
                  </span>
                </button>
                {isOpen && (
                  <div style={{ padding: "0 20px 20px", fontFamily: font, fontSize: 15.5, lineHeight: 1.65, color: C.muted }}>
                    {it.a}
                  </div>
                )}
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
